import React, { ImgHTMLAttributes } from 'react';

type Props = ImgHTMLAttributes<SVGElement>;

const Maintenance: React.FC<Props> = ({ className }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg
    width='144'
    height='145'
    viewBox='0 0 144 145'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M137.363 80.6433C137.363 82.9443 135.873 85.2787 132.661 87.1351L129.915 88.7247L60.4057 128.832C51.6906 133.856 36.8171 131.555 33.6268 124.686L10.6498 75.1741L7.19253 67.7374C6.83334 66.9796 6.64366 66.1527 6.63672 65.3141C6.63672 62.146 9.49378 59.3114 13.7957 57.6551C17.952 56.1289 22.4324 55.7038 26.8016 56.4212L34.7718 57.6551L125.446 71.6836C133.005 72.8397 137.363 76.697 137.363 80.6433Z'
      fill='black'
      fillOpacity='0.16'
    />
    <path
      d='M130.084 46.3947L130.084 46.395L60.5744 86.5021L60.5743 86.5021C56.1338 89.0622 50.1544 89.7449 44.8929 88.9305C42.2586 88.5227 39.7881 87.7375 37.767 86.6109C35.7478 85.4853 34.1574 84.0073 33.3207 82.2056L33.3206 82.2055L10.3437 32.6943L10.3436 32.6941L6.88755 25.2599C6.88737 25.2595 6.88718 25.2591 6.887 25.2587C6.50716 24.4569 6.30658 23.582 6.29923 22.6948L6.29921 22.692C6.29922 19.3073 9.33316 16.3895 13.6745 14.718L13.6794 14.7161L13.6794 14.7162C17.8899 13.1701 22.4286 12.7394 26.8548 13.4658C26.8553 13.4659 26.8558 13.466 26.8563 13.466L34.8234 14.6995L34.8234 14.6995L125.54 28.7388C125.541 28.7389 125.541 28.739 125.542 28.739C129.342 29.3014 132.369 30.5698 134.454 32.2193C136.539 33.8682 137.7 35.9165 137.7 38.0212C137.7 40.485 136.104 42.9131 132.83 44.8051L130.084 46.3947ZM130.084 46.3947L132.83 44.8053L130.084 46.3947Z'
      fill='var(--color-lightgrey-100)'
      stroke='var(--color-lightgrey-800)'
      strokeWidth='0.675'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M62.2146 45.7606C62.2204 45.7577 62.226 45.7547 62.2316 45.7514C63.96 44.749 64.9009 43.391 64.9009 41.9718C64.9009 40.5515 63.9587 39.2099 62.2291 38.2407C62.2285 38.2404 62.2278 38.24 62.2272 38.2396L45.3011 28.4707C45.2959 28.4677 45.2906 28.4648 45.2852 28.4621C43.3659 27.4871 41.2435 26.9789 39.0907 26.9789C36.9379 26.9789 34.8155 27.4871 32.8961 28.4621C32.8908 28.4648 32.8856 28.4677 32.8804 28.4706C31.1513 29.4678 30.2104 30.8232 30.2104 32.2493C30.2104 33.6752 31.151 35.0333 32.8797 36.0359L32.8809 36.0366L49.8 45.7522C49.8051 45.7551 49.8103 45.758 49.8157 45.7606C51.7376 46.733 53.8612 47.2397 56.0151 47.2397C58.1691 47.2397 60.2927 46.733 62.2146 45.7606Z'
      fill='var(--color-digitalcobalt-400)'
      stroke='var(--color-lightgrey-800)'
      strokeWidth='0.675'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M88.8181 54.1247L89.324 53.8325L88.8181 53.5403L76.7349 46.5593L76.5661 46.4618L76.3973 46.5593L64.303 53.5402L63.7966 53.8325L64.303 54.1248L76.3973 61.1058L76.5661 61.2032L76.7349 61.1057L88.8181 54.1247Z'
      fill='var(--color-digitalcobalt-400)'
      stroke='var(--color-lightgrey-800)'
      strokeWidth='0.675'
      strokeMiterlimit='10'
    />
    <path
      d='M137.7 38.0245C137.7 37.8381 137.549 37.687 137.363 37.687C137.176 37.687 137.025 37.8381 137.025 38.0245C137.025 40.1637 135.642 42.4042 132.546 44.2247C132.546 44.225 132.546 44.2252 132.545 44.2254L129.802 45.8137L129.802 45.8139L60.3373 85.9207C56.0627 88.3851 50.2479 89.0641 45.0962 88.2667C42.5239 87.8686 40.1332 87.1045 38.1958 86.0246C36.2567 84.9436 34.7915 83.5578 34.033 81.9246L34.0328 81.9242L10.9558 32.4131L10.9557 32.4128L7.49857 24.9764L7.49858 24.9764L7.4975 24.9741C7.15932 24.2606 6.98075 23.482 6.97421 22.6925C6.97267 22.5067 6.82117 22.357 6.63532 22.3578C6.44947 22.3586 6.29922 22.5095 6.29922 22.6953L6.29921 38.6248L6.29923 38.6276C6.30658 39.5147 6.50713 40.3896 6.88693 41.1914C6.88714 41.1918 6.88735 41.1922 6.88755 41.1927L33.3207 98.1494L33.3207 98.1495C34.1574 99.9512 35.7478 101.429 37.7671 102.555C39.7881 103.681 42.2587 104.466 44.8929 104.873C50.1545 105.686 56.1341 105 60.5746 102.435L132.829 60.7492L132.83 60.7491C136.104 58.8569 137.7 56.4287 137.7 53.954V38.0245Z'
      fill='var(--color-lightgrey-200)'
      stroke='var(--color-lightgrey-800)'
      strokeWidth='0.675'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export { Maintenance };
